module.exports = "/src/views/player/hudevo/ipad/assets/images/mech.png";